const CHANGE_ACTIVE_TODO_ID = "CHANGE_ACTIVE_TODO_ID";
const TOGGLE_EDITING_TITLE = "TOGGLE_EDITING_TITLE";
const TOOGLE_DELETING_TODO = "TOOGLE_DELETING_TODO";
const TOGGLE_TODO_EDIT_PANEL = "TOGGLE_TODO_EDIT_PANEL";
const TOGGLE_CHOOSE_DEADLINE_MODAL = "TOGGLE_CHOOSE_DEADLINE_MODAL";
const TOGGLE_IS_SHOWING_CALENDAR = "TOGGLE_IS_SHOWING_CALENDAR";

export { 
    CHANGE_ACTIVE_TODO_ID,
    TOGGLE_EDITING_TITLE,
    TOOGLE_DELETING_TODO,
    TOGGLE_TODO_EDIT_PANEL, 
    TOGGLE_CHOOSE_DEADLINE_MODAL, 
    TOGGLE_IS_SHOWING_CALENDAR };